module.exports = __webpack_public_path__ + "static/media/exxaro-logo.11547eb2.svg";